'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import iconChat from '@/assets/images/common/footer/icon-chat.svg'
import iconInstagram from '@/assets/images/common/footer/icon-instagram.svg'
import iconStore from '@/assets/images/common/footer/icon-store.svg'
import FooterInfoLinks from '@/components/Layout/Footer/Molecules/FooterInfoLinks'
import BackToTop from '@/components/Layout/Footer/Organisms/BackToTop'
import '@/components/Layout/Footer/Organisms/Footer/Footer.scss'
import FooterLinksUnion from '@/components/Layout/Footer/Organisms/FooterLinksUnion'
import { useSmoothScroll } from '@/components/hooks/useSmoothScroll'
import { inquiryUrl, instagramRedirectPath } from '@/utils/const'

const FOOTER_INFO = [
  {
    labelEn: 'Instagram',
    labelJa: 'インスタグラム',
    iconImage: iconInstagram,
    description: (
      <>
        ブランドの誕生ストーリーを
        <br />
        詳しく紹介しています。
      </>
    ),
    href: instagramRedirectPath,
  },
  {
    labelEn: 'Customer Service',
    labelJa: 'カスタマー窓口',
    iconImage: iconChat,
    description: <>数日以内にご返信いたします。</>,
    href: inquiryUrl,
  },
  {
    labelEn: 'Store',
    labelJa: '店舗情報',
    iconImage: iconStore,
    description: (
      <>
        FASの店舗では専任スタッフが
        <br />
        商品選びのご相談を承っております。
      </>
    ),
    href: '/store/',
  },
] as const

export type Props = {
  onClickBackToTop?: (() => void) | null
  ableToBrowsing?: boolean
}

export default function FooterLogic({ ableToBrowsing = true }: Props) {
  const { scrollToTop } = useSmoothScroll()
  const [fixDesign, setFixDesign] = useState(!ableToBrowsing)

  const pathname = usePathname()
  useEffect(() => {
    if (pathname.startsWith('/crm-carts') || pathname.startsWith('/market-carts') || pathname.startsWith('/orders')) {
      setFixDesign(true)
    } else if (!fixDesign) {
      setFixDesign(false)
    }
  }, [pathname])

  if (fixDesign) {
    return <></>
  }

  return (
    <footer className="c-footer">
      <FooterInfoLinks items={FOOTER_INFO} />
      <FooterLinksUnion />
      <div className="c-footer__bottom">
        <div className="c-footer__button">
          <BackToTop onClickBackToTop={() => scrollToTop()} />
        </div>
        <ul className="c-footer__legal">
          <li className="c-footer__legal-item">
            <Link className={'u-mo-crop'} href={'/company'}>
              <span className="u-mo-crop__text u-mo-crop__text--inner">Company</span>
              <span className="u-mo-crop__text u-mo-crop__text--outer">Company</span>
            </Link>
          </li>
          <li className="c-footer__legal-item">
            <Link className={'u-mo-crop'} href={'/laws'}>
              <span className="u-mo-crop__text u-mo-crop__text--inner">Law</span>
              <span className="u-mo-crop__text u-mo-crop__text--outer">Law</span>
            </Link>
          </li>
          <li className="c-footer__legal-item">
            <Link className={'u-mo-crop'} href={'https://sirok.co.jp/privacy-policy'}>
              <span className="u-mo-crop__text u-mo-crop__text--inner">Privacy Policy</span>
              <span className="u-mo-crop__text u-mo-crop__text--outer">Privacy Policy</span>
            </Link>
          </li>
          <li className="c-footer__legal-item">
            <Link className={'u-mo-crop'} href={'/terms'}>
              <span className="u-mo-crop__text u-mo-crop__text--inner">Terms</span>
              <span className="u-mo-crop__text u-mo-crop__text--outer">Terms</span>
            </Link>
          </li>
          <li className="c-footer__legal-item c-footer__legal-item--copyright">
            <p className="c-footer__legal-text">© 2023 FAS</p>
          </li>
        </ul>
      </div>
    </footer>
  )
}
